import React, {useEffect, useState, lazy, Suspense} from 'react';
import {Loader} from '../components';

const LazySubSignin = lazy(() => import('./SubdomainAuths/SubSignin'));
const LazySignin = lazy(() => import('./Auths/Signin'));
const LazyReconciloSignIn = lazy(() =>
  import('./FraudDetection/Reconciliation/Auth/ReconciloSignIn'),
);

const SignInUser = () => {
  const [domain, setDomain] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const subDomainUser = localStorage.getItem('subdomain');
    setDomain(subDomainUser);
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  const isReconcilo = domain?.includes('reconcilo');
  const isTrypila = domain?.includes('trypila');
  const isVeldro = domain?.includes('veldro');
  const isProfiledRisk = domain?.includes('profiledrisk');

  const ComponentToRender =
    isReconcilo || isTrypila || isProfiledRisk || isVeldro
      ? LazyReconciloSignIn
      : domain
      ? LazySubSignin
      : LazySignin;

  return (
    <Suspense fallback={<Loader />}>
      <ComponentToRender />
    </Suspense>
  );
};

export default SignInUser;
